import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import useStyles from "./button-styles";

function MyButton(props) {
  const classes = useStyles();
  const {
    children,
    styles,
    gradient,
    isSubmitted,
    disableButtonColor,
    isdiv,
    disabled,
    ...buttonProps
  } = props;
  function renderBtnInner() {
    if (!isSubmitted) {
      return children;
    }
    return <CircularProgress className={classes.circularStyle} size={24} />;
  }
  function renderGradientBg() {
    if (disabled) {
      if (gradient && disableButtonColor) {
        return `${classes.gradientBg} ${classes.ctnDisabled}`;
      }
    }
    if (gradient) {
      return classes.gradientBg;
    }
    return null;
  }
  if (isdiv) {
    return (
      <div className={clsx(classes.root, styles, renderGradientBg())} {...buttonProps}><span className={classes.isDiv}>{renderBtnInner()}</span></div>
    );
  }
  return (
    <Button
      disabled={disabled}
      className={clsx(classes.root, styles, renderGradientBg())}
      {...buttonProps}
    >
      {renderBtnInner()}
    </Button>
  );
}

MyButton.propTypes = {
  children: PropTypes.node.isRequired,
  styles: PropTypes.string,
  gradient: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isSubmitted: PropTypes.bool,
  isdiv: PropTypes.string,
  disabled: PropTypes.bool,
};

MyButton.defaultProps = {
  styles: "",
  gradient: false,
  isSubmitted: false,
  isdiv: "",
  disabled: false,
};

export default MyButton;
